import apiClient from "./api";
const EGRESOSINGRESOS_API_BASE_URL = "/egresosingresos";
class EgresosIngresosService {
  getEgresosIngresos() {
    return apiClient.get(EGRESOSINGRESOS_API_BASE_URL);
  }
  getEgresosIngresosActual(sucursalId) {
    return apiClient.get(`${EGRESOSINGRESOS_API_BASE_URL}/actual/${sucursalId}`);
  }

  async getEgresosIngresosPorCorte(idSucursal, idCorte) {
    try {
      const response = await apiClient.get(
        `${EGRESOSINGRESOS_API_BASE_URL}/corte/${idSucursal}/${idCorte}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  agregarEgresosIngresos(egresosIngresos) {
    return apiClient.post(EGRESOSINGRESOS_API_BASE_URL, egresosIngresos);
  }
  updateEgresosIngresos(egresosIngresos) {
    return apiClient.put(EGRESOSINGRESOS_API_BASE_URL , egresosIngresos);
  }
  eliminarEgresosIngresos(id) {
    return apiClient.delete(`${EGRESOSINGRESOS_API_BASE_URL}/${id}`);
  }

  async buscarEgresosIngresos(busqueda) {
        try {
            const response = await apiClient.post(
                `${EGRESOSINGRESOS_API_BASE_URL}/buscar`,
                { busqueda },
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }
    
}
export default new EgresosIngresosService();
